<template>
  <div class="container" id="error-content">
    <v-row justify="center" class="section_inner box py-8">
      <v-col cols="12" md="6">
        <br />
        <h1 class="display-60 primary--text">
          זה לא אתם...
          <span class="d-block pa-0 ">זה אנחנו :)</span>
        </h1>
        <p class="display-22 pa-0 mt-1">
          עובדים על שיפורים ושדרוגים, מצטערים על אי הנוחות הזמנית! אוטוטו
          חוזרים...
        </p>
      </v-col>
      <v-col cols="12" md="6">
        <v-img
          class="ilus px-2"
          :src="require(`@/assets/ilus.png`)"
          :max-width="$vuetify.breakpoint.smAndDown ? 300 : 500"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gtm from '@/lib/gtm';
export default {
  name: 'error-500',
  props: ['error'],

  mounted() {
    gtm({
      category: this.error.statusCode,
      action: this.error.path,
      event: '500',
    });
  },
};
</script>

<style lang="scss" scoped>
h1 {
  line-height: initial;
}
#error-content {
  text-align: center;
}
.box {
  box-shadow: 0 0 4px #c7c7c7;
}
.ilus {
  // max-width: 300px;
  margin: auto;
  @media only screen and (min-width: 768px) {
    // max-width: 600px;
  }
}
</style>